import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { logger } from 'redux-logger'
import { rootReducer, createReducer } from '../reducers'

const composeEnhancers =
  typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    process.env.NODE_ENV !== 'production'
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose

const middleware = [thunkMiddleware]

// process.env.NODE_ENV !== 'production' && middleware.push(logger)

const enhancer = composeEnhancers(
  applyMiddleware(...middleware)
  // other store enhancers if any
)
// const store = createStore(rootReducer, enhancer)

function configureStore() {
  const store = createStore(createReducer(), enhancer);
  return store;
}

export default configureStore()
